import { Check } from "@phosphor-icons/react";
import { CANCEL_ORDER, CHECK_DELIVERY_URL, CREATE_ORDER_URL, LIST_ORDERS_URL, TRACK_ORDERS_URL, VIEW_ORDERS_URL } from "../../../../../constants";
import { apiSlice } from "./apiSlice";

export const orderApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    CheckDelivery: builder.mutation({
      query: ({ address_id, order_items, cod, token }) => ({
        url: CHECK_DELIVERY_URL,
        method: "POST",
        body: {
          address_id,
          cod : 0 ,
          order_items
        },
        headers: {
          Authorization: token ? `Bearer ${token}` : '', 
        },
      }),
    }),
    createOrder: builder.mutation({
      query: ({ address_id, order_items, token ,coupon_code ,courier_id ,delivery_fee }) => ({
        url: CREATE_ORDER_URL,
        method: "POST",
        body: {
          payment_type: 3, // Fixed payment type
          delivery_fee,
          courier_id,
          address_id,
          order_items,
          ...(coupon_code && { coupon_code }),
        },
        headers: {
          Authorization: token ? `Bearer ${token}` : '', 
        },
      }),
    }),
    listOrders: builder.query({
      query: ({ token, limit, page }) => {
        const params = {
          limit,
          page,
        };
        
        return {
          url: LIST_ORDERS_URL,
          method: 'GET',
          params,
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        };
      },
    }),
    showOrder: builder.query({
      query: ({ id, token }) => ({
        url: `${VIEW_ORDERS_URL}/${id}`,
        method: 'GET',
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }),
    }),   
    cancelOrder: builder.mutation({
      query: ({ data, token }) => {
        return {
          url: CANCEL_ORDER,
          method: "POST",
          body: data,
          headers: {
              Authorization: token ? `Bearer ${token}` : '', 
          },
        };
      },
    }),
    trackOrder: builder.query({
        query: ({ awb, token }) => ({
            url: TRACK_ORDERS_URL,
            method: "POST",
            body: {
                awb,
            },
            headers: {
                Authorization: token ? `Bearer ${token}` : '',
            },
        }),
    }),
  }),
});

export const { useCheckDeliveryMutation, useCreateOrderMutation, useListOrdersQuery, useShowOrderQuery, useCancelOrderMutation, useTrackOrderQuery } = orderApiSlice;
